module.exports = __webpack_public_path__ + "static/media/atu.61f0f59b.png";